import React from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import { Text } from '@atomic';
import { COLOR_FONT_GRAY } from '@assets/color';
import moment from 'moment';

const getTimeAgo = (time) => {
  const { now, created } = time;
  let timeAgo = '';

  if (now.diff(created, 'years') > 0) {
    timeAgo = `${now.diff(created, 'years')} 년전`;
  } else if (now.diff(created, 'months') > 0) {
    timeAgo = `${now.diff(created, 'months')} 달전`;
  } else if (now.diff(created, 'weeks') > 0) {
    timeAgo = `${now.diff(created, 'weeks')} 주전`;
  } else if (now.diff(created, 'days') > 0) {
    timeAgo = `${now.diff(created, 'days')} 일전`;
  } else if (now.diff(created, 'hours') > 0) {
    timeAgo = `${now.diff(created, 'hours')} 시간전`;
  } else {
    timeAgo = `${now.diff(created, 'minutes')} 분전`;
  }

  return timeAgo;
};
const TimeTextWrapper = styled(Text)`
  margin-bottom: 3px;

  &:after {
    font-size: 14px;
    content: '${({ timeAgo }) => ' · ' + timeAgo}';
    color: ${COLOR_FONT_GRAY};
  }
`;

const TimeText = ({ userName, createdAt, ...props }) => {
  const time = {
    created: moment(createdAt)._d,
    now: moment(),
  };

  return (
    <TimeTextWrapper
      {...props}
      block
      strong
      textSize={16}
      timeAgo={getTimeAgo(time)}
    >
      {userName}
    </TimeTextWrapper>
  );
};

TimeText.propTypes = {
  userName: PropTypes.string,
  createdAt: PropTypes.string,
};

export default TimeText;
